import { cn } from "@/lib/utils";

export function Input({ className, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      className={cn(
        "field-3d h-10 w-full px-3 text-sm text-[var(--text)] placeholder:text-[var(--text-faint)] outline-none",
        className,
      )}
      {...props}
    />
  );
}

export function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      className={cn(
        "field-3d min-h-28 w-full px-3 py-2 text-sm text-[var(--text)] placeholder:text-[var(--text-faint)] outline-none",
        className,
      )}
      {...props}
    />
  );
}

export function Label({ className, ...props }: React.ComponentProps<"label">) {
  return (
    <label className={cn("mb-1.5 block text-xs text-[var(--text-muted)]", className)} {...props} />
  );
}

export function Select({ className, ...props }: React.ComponentProps<"select">) {
  return (
    <select
      className={cn("field-3d h-10 w-full px-3 text-sm text-[var(--text)] outline-none", className)}
      {...props}
    />
  );
}
